import React from "react";
import { ArrowRight, ChevronRight } from "lucide-react";

export const FeatureCard = ({ 
  title, 
  description, 
  onClick, 
  icon: Icon, 
  gradient = "bg-gradient-to-br from-blue-600 to-indigo-600",
  delay = 0 
}) => (
  <div
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyPress={(e) => e.key === "Enter" && onClick()}
    className="group bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer"
    style={{ animationDelay: `${delay}ms` }}
  >
    {/* Gradient Header */}
    <div className={`${gradient} p-6 relative overflow-hidden`}>
      <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
      <div className="relative z-10 flex items-center justify-between">
        <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl">
          <Icon className="w-6 h-6 text-white" />
        </div>
        <ArrowRight className="w-5 h-5 text-white/80 group-hover:text-white group-hover:translate-x-1 transition-all duration-200" />
      </div>
      
      {/* Enhanced Decorative Elements */}
      <div className="absolute -top-8 -right-8 w-24 h-24 bg-white/10 rounded-full"></div>
      <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-white/10 rounded-full"></div>
      <div className="absolute top-2 right-16 w-6 h-6 bg-white/10 rounded-full"></div>
    </div>

    {/* Content */}
    <div className="p-6">
      <h3 className="text-xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-3 group-hover:from-blue-600 group-hover:to-indigo-600 transition-all duration-300">
        {title}
      </h3>
      <p className="text-slate-600 leading-relaxed mb-4">
        {description}
      </p>
      
      {/* Action Indicator */}
      <div className="flex items-center gap-2 pt-4 border-t border-slate-100">
        <span className="text-sm font-semibold text-blue-600 group-hover:text-blue-700 transition-colors duration-200">
          Access Feature
        </span>
        <ChevronRight className="w-4 h-4 text-blue-600 group-hover:text-blue-700 group-hover:translate-x-1 transition-all duration-200" />
      </div>
    </div>

    {/* Hover Glow Effect */}
    <div className="absolute inset-0 bg-gradient-to-r from-blue-600/0 via-indigo-600/0 to-purple-600/0 group-hover:from-blue-600/10 group-hover:via-indigo-600/10 group-hover:to-purple-600/10 transition-all duration-500 pointer-events-none rounded-2xl"></div>
  </div>
);